import {MenuItem, TextField} from '@mui/material';

import {useGetBans} from '@entities/user';
import {FilterRow} from '@shared/components/filters';
import {useUrlState} from '@shared/hooks';
import {PaginationState} from '@shared/types';
import {Header} from '@widgets/common';
import {UserBansTable} from '@widgets/user';

type UrlState = PaginationState & {active: 'all' | 'active' | 'lifted'};

export const BansPage = () => {
  const {urlState, setUrl} = useUrlState<UrlState>({
    pageIndex: 0,
    pageSize: 10,
    active: 'all',
  });
  const {data, isPending, error} = useGetBans({
    page: urlState.pageIndex + 1,
    pageSize: urlState.pageSize,
    active:
      urlState.active === 'all' ? undefined : urlState.active === 'active',
  });
  return (
    <>
      <Header title="User bans" mb={2} />
      <UserBansTable
        showUser
        data={data?.items ?? []}
        error={error}
        localStorageKeyForSettings="userBansTable"
        enablePagination
        manualPagination
        rowCount={data?.total ?? 0}
        state={{isLoading: isPending, pagination: urlState}}
        onPaginationChange={updater =>
          setUrl((prev: UrlState) => ({
            ...prev,
            ...(typeof updater === 'function' ? updater(prev) : updater),
          }))
        }
        renderTopToolbarCustomActions={() => (
          <FilterRow>
            <TextField
              select
              label="Status"
              size="small"
              sx={{minWidth: 160}}
              value={urlState.active}
              onChange={event => {
                const active = event.target.value as UrlState['active'];
                setUrl((prev: UrlState) => ({...prev, pageIndex: 0, active}));
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="lifted">Lifted</MenuItem>
            </TextField>
          </FilterRow>
        )}
      />
    </>
  );
};
